import type { components } from '@/api/generated/fct';

type NextRecommendedScanOption = components['schemas']['NextRecommendedScanOption'];

const VALID_NEXT_RECOMMENDED_SCAN_OPTIONS = new Set<NextRecommendedScanOption>([0, 6, 12, 24]);

export function toNextRecommendedScanOption(
  value: null | number | string | undefined,
): NextRecommendedScanOption {
  const numericValue = Number(value ?? 0);

  return VALID_NEXT_RECOMMENDED_SCAN_OPTIONS.has(numericValue as NextRecommendedScanOption)
    ? (numericValue as NextRecommendedScanOption)
    : 12;
}
